import type { ReactNode } from 'react';

export function formatDate(iso: string): string {
  if (!iso) return '—';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

const thClass = 'border-b border-grey-20 px-3 py-2 text-left text-xs font-medium text-grey-60';
export const tdClass = 'border-b border-grey-10 px-3 py-2 align-top';

export function Table({
  headers,
  children,
  testid,
  label,
}: {
  headers: string[];
  children: ReactNode;
  testid: string;
  label?: string;
}) {
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse text-sm" data-testid={testid} aria-label={label}>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header} className={thClass}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export function EmptyRow({ colSpan, message }: { colSpan: number; message: string }) {
  return (
    <tr>
      <td className={`${tdClass} text-grey-60`} colSpan={colSpan}>
        {message}
      </td>
    </tr>
  );
}
